import React, { Component } from 'react';
import glamorous from 'glamorous'
import Modal from '../../common/Modal';
import Button from '../../blocks/Button';
import ButtonSet from '../../blocks/ButtonSet';
import TextInput from '../../common/TextInput';
import Checkbox from '../../common/Checkbox';
import Container from '../../blocks/Container';
import InputGroup from '../../blocks/InputGroup'
import { color, textColor } from '../../../style';

const listPadding = {
  paddingBottom: 10
}

const ListItem = glamorous.li({
  ...listPadding
})

const Permanent = glamorous.li({
  fontWeight: 'bold',
  ...textColor.RED,
  ...listPadding
})

const CheckboxPass = glamorous.div({
  paddingBottom: 16
})

const HeaderGDPR = glamorous.h3({
  textAlign: 'center',
  fontSize: 20,
  color: color.BRAND_1
})

const HeaderConfirm = glamorous.h4({
  color: color.BRAND_1_DARK,
  textAlign: 'center'
})

const GDPRContainer = glamorous.div({
  margin: '0 30px'
})

class GdprDeletionModal extends Component {
  state = {
    password: '',
    confirm_delete: false
  }

  onChangeHandler = (e) => {
    this.setState({[e.target.id]: e.target.value});
  }

  onCheckboxChange = (e) => {
    this.setState({[e.target.id]: !this.state[e.target.id]})
  }

  handleYes = () => {
    const formData = {
      'password': this.state.password,
      'confirm_delete': this.state.confirm_delete
    }

    this.props.requestGdprDeletion(formData);
  }

  render() {
    const {
      isOpen,
      handleYes,
      yesBtnMsg,
      noBtnMsg,
      handleClose,
      profile,
      hasError
    } = this.props;

    return (
      <Modal
        openStatus={isOpen}
        disableClose={true}
      >
        <GDPRContainer>
          <HeaderGDPR> GDPR Account Deletion </HeaderGDPR>
          <ul>
            <Permanent> THIS IS PERMANENT! </Permanent>
            <ListItem> All data on MissTravel will be deleted and unrecoverable </ListItem>
            <ListItem> If you want to use MissTravel again, you'll need to create a new account and fill out your profile again </ListItem>
          </ul>

          <HeaderConfirm> Are you sure you want to delete your account? </HeaderConfirm>
          <CheckboxPass>
            <Checkbox
              value={this.state.confirm_delete}
              id="confirm_delete"
              label="I confirm the deletion of my MissTravel account"
              onChange={this.onCheckboxChange}
            />

            <InputGroup vertical inputLabel="Password:">
              <TextInput
                type='password'
                id='password'
                value={this.state.password}
                onChange={this.onChangeHandler}
                error={hasError}
              />
            </InputGroup>
          </CheckboxPass>
          <ButtonSet 
            align="center"
          >
            <Button
              variant="primary"
              onClick={this.handleYes}
              disabled={this.state.password === '' || !this.state.confirm_delete}
            >
              {yesBtnMsg || 'Yes'}
            </Button>
            <Button
              variant="simple"
              onClick={() => { handleClose() } }
            >
              {noBtnMsg || 'No'}
            </Button>
          </ButtonSet>
        </GDPRContainer>
      </Modal>
    )
  }
}

export default GdprDeletionModal;



// WEBPACK FOOTER //
// ./src/components/pages/GDPR/GdprDeletionModal.jsx